import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import s from './Footer.module.css';
import { useSiteProfile } from '../../../Portfolio/ProfileContext';

const Footer = () => {
    const { t } = useTranslation();
    const profile = useSiteProfile();
    return (
        <footer className={s.footer}>
            <div className={s.footerInner}>
                <Link to="/" className={s.footerBrand}>CodeCognition <span>by {profile.displayName}</span></Link>
                <div className={s.footerLinks}>
                    <Link to="/projects">{t('nav.projects')}</Link>
                    <Link to="/writing">{t('nav.writing')}</Link>
                    <Link to="/about">{t('nav.about')}</Link>
                    <a href={`mailto:${profile.email}`}>{t('footer.email')}</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
